import {h, Component, RefObject, createRef} from 'preact'
import axios from 'axios'
import Phrase from '../../libs/translationsUtils/phrase'
import {instantiatePreactComponents} from '../../libs/preact-entry'
import globals from '../../utils/globals'

interface Props {
  url: string
}

interface State {
  embedCode: string,
  hasError: boolean,
  hasAccess: boolean,
}


class OEmbed extends Component<Props> {
  private ref: RefObject<HTMLElement> = createRef()

  constructor() {
    super()
    this.state = {
      embedCode: '',
      hasError: false,
      hasAccess: false
    }
  }

  componentDidMount() {
    axios.get('/oembed/getembeddedUrl?url=' + this.props.url)
      .then(res => {
        this.setState({embedCode: res.data.html.replace('http://', 'https://'), hasAccess: true})
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          this.setState({hasError: true})
        } else {
          this.setState({hasError: true, hasAccess: true})
        }
      })
  }

  componentDidUpdate() {
    if (this.ref.current) {
      instantiatePreactComponents(this.ref.current)
    }
  }

  render(props: Props, state: State) {
    let isEmbedTopicCard

    try {
      const embedUrl = new URL(props.url)
      isEmbedTopicCard = embedUrl.host ===  new URL(globals('communityUrl') as string).host
    } catch {
      isEmbedTopicCard = false
    }

    if (!state.hasAccess) {
      return (
        <a target='_blank' href={props.url} rel='noreferrer nofollow noopener' style={{ display: `${isEmbedTopicCard ? 'block': 'inline'}` }}>{props.url}</a>
      )
    }
    if (state.hasError && isEmbedTopicCard) {
      return (
        <a target='_blank' href={props.url} rel='noreferrer nofollow noopener' style={{ display: 'block' }}>{props.url}</a>
      )
    }
    return (
      <div className='oembed-wrapper'>
        {
          state.hasError
            ? <div className='box box__pad box--note'>
              <Phrase p='embeddable.not.available' />
            </div>
            : <div ref={this.ref} className={state.embedCode.indexOf('<iframe') >= 0 ? 'oembed-iframe-wrapper' : ''} dangerouslySetInnerHTML={{__html: state.embedCode}} />
        }
      </div>
    )
  }
}

export default OEmbed
